var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 493.456 493.456",
    viewBox: "0 0 493.456 493.456",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m246.73 0c-136.048 0-246.728 110.68-246.728 246.724 0 136.048 110.68 246.732 246.728 246.732s246.724-110.684 246.724-246.732c0-136.044-110.676-246.724-246.724-246.724zm92.544 321.828c0 9.5-7.924 17.44-17.44 17.44h-148.596c-9.504.004-19.048-9.768-19.048-19.276v-148.356c0-9.496 7.944-17.448 17.448-17.448h150.196c9.516 0 17.44 7.952 17.44 17.448z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.ad4f360e71c59d597eb711c7abd9c3f2.svg";
export { ForwardRef as ReactComponent };